import React from "react";
// Chakra imports
import { Box, useColorMode, useColorModeValue } from "@chakra-ui/react";
// Custom Components
import LandingNavbar from "components/Navbars/LandingNavbar";

const Landing = ({ children }) => {
  const { colorMode } = useColorMode();

  const gradient = useColorModeValue(
    "linear-gradient(180deg, #3182CE 0%, #63B3ED 100%)", // Light mode gradient
    "linear-gradient(180deg, #2D3748 0%, #4A5568 100%)" // Dark mode gradient (adjust as needed)
  );

  return (
    <Box minH="100vh" bg={gradient} position="relative">
      <LandingNavbar />
      {children}
    </Box>
  );
};

export default Landing;
